var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.savingStatus)?_c('div',{staticClass:"mr-2"},[(_vm.savingStatus === 'SAVING')?_c('span',[_vm._v("Saving...")]):_vm._e(),(_vm.savingStatus === 'SAVED')?_c('span',[_vm._v("Saved")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }